<template>
  <div class="receipt-overlay no-print" @click.self="$emit('close')">
    <div class="receipt-box" role="dialog" aria-labelledby="send-receipt-title">
      <h3 id="send-receipt-title" class="receipt-title">
        {{ isRefund ? "Send refund receipt" : "Send receipt by email" }}
      </h3>
      <p class="receipt-hint">The receipt will be sent to:</p>
      <input
        ref="email"
        v-model="email"
        type="email"
        class="receipt-input"
        placeholder="Email address"
        @keyup.enter="send"
      />
      <p
        v-if="result"
        class="receipt-result"
        :class="result.success ? 'text-green-700' : 'text-red-700'"
      >
        {{ result.message }}
      </p>
      <div class="receipt-actions">
        <button class="receipt-btn" @click="$emit('close')">
          {{ result && result.success ? "Close" : "Cancel" }}
        </button>
        <button
          class="receipt-btn receipt-btn--primary"
          :disabled="sending || !validEmail"
          @click="send"
        >
          {{ sending ? "Sending..." : "Send" }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
// Pide el email y envía el recibo con la función que reciba (POS o web).
export default {
  name: "SendReceiptModal",
  props: {
    defaultEmail: { type: String, default: "" },
    // (email) => Promise
    sendFn: { type: Function, required: true },
    isRefund: { type: Boolean, default: false }
  },
  data() {
    return {
      email: this.defaultEmail || "",
      sending: false,
      result: null
    };
  },
  computed: {
    validEmail() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email.trim());
    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.email && this.$refs.email.focus());
  },
  methods: {
    async send() {
      if (this.sending || !this.validEmail) return;
      this.sending = true;
      this.result = null;
      try {
        await this.sendFn(this.email.trim());
        this.result = { success: true, message: "Receipt sent successfully." };
      } catch (err) {
        this.result = {
          success: false,
          message:
            err.response?.data?.message ||
            "Failed to send receipt. Please try again."
        };
      } finally {
        this.sending = false;
      }
    }
  }
};
</script>
<style scoped>
.receipt-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
}
.receipt-box {
  width: 420px;
  max-width: 100%;
  padding: 24px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}
.receipt-title {
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}
.receipt-hint {
  margin: 0 0 12px;
  font-size: 14px;
  color: #6b7280;
}
.receipt-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
}
.receipt-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}
.receipt-result {
  margin: 10px 0 0;
  font-size: 14px;
}
.receipt-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}
.receipt-btn {
  padding: 8px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}
.receipt-btn:hover {
  background: #f9fafb;
}
.receipt-btn--primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}
.receipt-btn--primary:hover {
  background: #1d4ed8;
}
.receipt-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
